/*
 * お客様の声ページ — Judge.me ウィジェットの文言を整える
 *
 * 2026-08-29 全面改訂。
 * Judge.me がウィジェットを刷新してクラス名が jdgm- から jm- に変わり、
 * 旧版が触っていた 10 種のクラスが実物に 1 件も無くなっていた。
 *
 * 旧版は 4 つの整形をしていたが、実測したところ 3 つは不要になっていた:
 *   1. 平均評価「5つ星中5.00つ星」→「5.00」…… 新版は最初から「5.0」
 *   2. 「に基づく」を消す ………………………… 新版は「1 件のレビュー」で出ない
 *   3. 認証マークの画像を消す …………………… 新版はその画像を出さない
 *   4. 投稿者のカスタム項目を組み直す ………… 新版は投稿画面ごと別方式に変わり、
 *      レビューカードにカスタム項目が出ない（現状 0 件）
 *   5. 返信の見出しを組み直す ………………… 返信が 0 件のため現状は確認できない。
 *      返信が付いた時点で実物を見て、必要なら足す
 *
 * 残したのは、星の分布グラフの件数に「件」を足す処理だけ。
 *
 * ⚠️ アプリ側の更新でまた変わりうる。効かなくなったら
 *   scripts/audit-judgeme-class-rename.py で当社が指すクラスの一致件数を数える。
 */
(function () {
  var SELECTOR = ".jm-histogram-row__frequency";

  function addCountUnit() {
    var done = 0;
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var text = (el.textContent || "").trim();
      if (text && !text.endsWith("件")) {
        el.textContent = text + "件";
        done++;
      }
    });
    return done;
  }

  // ウィジェットは後から描画されるので、出てきたら 1 回だけ処理して監視を外す。
  // 対象が無いページ（商品ページ等）では発火しない。
  var observer = new MutationObserver(function () {
    if (document.querySelector(SELECTOR)) {
      addCountUnit();
      observer.disconnect();
    }
  });

  if (document.querySelector(SELECTOR)) {
    addCountUnit();
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
